import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import {
  addCalendarAsset, fetchCalendarAssets, fetchWebAssetTemplates, refreshCalendarAsset,
  setPageTitle, updateCalendarAsset,
} from 'signoxe/actions';
import { Page } from 'signoxe/components';
import Box from 'signoxe/components/layout/Box';
import Button from 'signoxe/components/widgets/Button';
import { getAsset, getCalendarAssetTemplates } from 'signoxe/selectors';

class CalendarAssetPage extends Component {
  constructor(props) {
    super(props);
    this.state = {...props.asset};
  }

  static propTypes = {
    fetchCalendarAssets: PropTypes.func.isRequired,
    refreshCalendarAsset: PropTypes.func.isRequired,
    fetchWebAssetTemplates: PropTypes.func.isRequired,
    updateCalendarAsset: PropTypes.func.isRequired,
    addCalendarAsset: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    asset: PropTypes.object,
    params: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    templates: PropTypes.array.isRequired,
  };

  handleCancel = () => this.props.history.push('/assets');

  handleNameChange = (e) => this.setState({name: e.currentTarget.value});

  handleRefresh = () => this.props.refreshCalendarAsset(this.props.asset);

  handleSave = () => {
    this.props.addCalendarAsset(this.state);
    // this.props.disable();
    setTimeout(this.props.refresh, 700)
  }

  handleTemplateChange = (e) => this.setState({template: e.currentTarget.value});

  handleUrlChange = (e) => this.setState({url: e.currentTarget.value});

  isNewAsset = () => this.props.match.params.id === undefined;

  componentDidMount() {
    this.props.fetchCalendarAssets();
    this.props.fetchWebAssetTemplates();
    this.props.setPageTitle('Adding Calendar Asset');
  }

  componentWillReceiveProps(newProps) {
    if (this.props.asset !== newProps.asset) {
      this.setState(newProps.asset);
    }
  }

  render() {

    const {name, template, url} = this.state;
    const templateData = this.props.templates.find(t => t.id == template);

    return (
      <div className="cal-asset-editing-page">
        <input type="text" placeholder="Asset name"
               value={name || ''}
               onChange={this.handleNameChange}/>
        <Box direction="row">
          <input type="url" placeholder="Calendar URL"
                 value={url}
                 onChange={this.handleUrlChange}/>
        </Box>
        <select id="template-selector" name="template-selector"
                value={template}
                onChange={this.handleTemplateChange}>
          <option value="NULL" key="null">----</option>
          {this.props.templates.map(template =>
            (<option key={template.id}
                     value={template.id}>{template.name}</option>),
          )}
        </select>
        {templateData &&
        <div className="help"
             dangerouslySetInnerHTML={{__html: templateData.help_html}}/>}
        {templateData && <iframe className='calendar-iframe' srcDoc={templateData.template}/>}
        <Box direction="row" justifyContent="flex-end" className="actions button-group">
          <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>Save</Button>
          {/* <Button secondary onClick={this.handleCancel}>Cancel</Button> */}
        </Box>
      </div>
    );
  }

  saveEnabled() {
    return this.state && this.state.name && this.state.url;
  }
}

export default connect(
  (state, {match}) => ({
    templates: getCalendarAssetTemplates(state),
  }), {
    fetchCalendarAssets,
    fetchWebAssetTemplates,
    refreshCalendarAsset,
    updateCalendarAsset,
    addCalendarAsset,
    setPageTitle,
  },
)(CalendarAssetPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Calendar.js